import md5 from 'js-md5';
import axios from 'axios'
axios.defaults.timeout = 5000;
axios.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		return Promise.reject(error);
	});

export async function report (itemid, downdata = '') {
	const {bindInfo: {openid: xyuin = ''} = {}} = window;
	let token = window.milo.cookie.get('access_token');
	const { activityid } = window.TAnalyticsfixedData
	let sysid = 3
	if (/Android/i.test(navigator.userAgent)) {
		sysid = 1
	} else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
		sysid = 2
	}
	let logintype = 1
	let sessionid = token || window.milo.cookie.get('skey');
	if (window.milo.cookie.get('acctype') === 'wx') {
		logintype = 2
	} else if (window.milo.cookie.get('acctype') === 'qc') {
		logintype = 3
	}
	const {gameId, actId} = window._Vue.$actConfig;
	let params = {
		dataid: '4000000000002',
		businessid: '1016',
		apiid: '00020002',
		pageid: '12001',
		itemtype: '1001',
		itemid: itemid,
		xyuin,
		activityid,
		time: (new Date()).getTime(),
		url: window.location.href,
		useragent: window.navigator.userAgent,
		sysid,
		logintype,
		sessionid,
		nettype: 8,
		eventtype: '1002',
		channelid: '12',
		moduleid: gameId,
		referrer: actId,
		ext: JSON.stringify(downdata)
	}
	window.milo.cookie.set('commid', xyuin);
	setTimeout(() => {
		axios.get('https://web.xinyue.qq.com/xya', {params: {params, id: '00020002'}}).catch(error => {
			console.log(error);
		});
	}, 1000);
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/buryingPoint/index.js